import { TextField, Button, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useFormik } from 'formik';
import { useAuth } from 'reactfire';
import { useSnackbar } from 'notistack';
import { AuthError } from 'firebase/auth';
import * as yup from 'yup';

import { AuthContainer, AuthForm } from '../../styled/AuthPage.styled';
import { forgotPassword, handleAuthError } from '../../utils/api/auth';

const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email('Неправильний email').required('Обов’язкове поле'),
});

const ForgotPasswordPage = () => {
  const auth = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: forgotPasswordSchema,
    async onSubmit({ email }, { setErrors }) {
      try {
        await forgotPassword(auth, email);

        enqueueSnackbar('Лист надіслано, перевірте свою пошту.', {
          variant: 'success',
        });
      } catch (error) {
        const message = handleAuthError(error as AuthError);

        setErrors({ email: message });
      }
    },
  });

  return (
    <AuthContainer maxWidth="xs">
      <Typography variant="h5" marginBottom={3}>
        Відновлення паролю
      </Typography>
      <AuthForm onSubmit={formik.handleSubmit}>
        <TextField
          id="email"
          name="email"
          autoComplete="email"
          label="Email"
          autoFocus
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={formik.isSubmitting}
        >
          Відправити
        </Button>
        <Link component={RouterLink} to="/login">
          Повернутись назад
        </Link>
      </AuthForm>
    </AuthContainer>
  );
};

export default ForgotPasswordPage;
